@if (isLoading) {
  <loader></loader>
}
<router-outlet />